export function callbackQueue<F extends (...args: any[]) => any>(f: F, ms: number): (...args: Parameters<F>) => void {
  let timeout

  return function (...args: Parameters<F>): void {
    clearTimeout(timeout)
    timeout = setTimeout(() => f(...args), ms)
  }
}
